import ProgressBar from "@ramonak/react-progress-bar";
import { useQueryClient } from "@tanstack/react-query";
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import Popup from "reactjs-popup";

import emptyImage from "../../../assets/images/emptyAvatar.svg";
import { useGetUserInformation, usersKeys } from "../../../features/users";
import useFileUpload from "../../../hooks/useFileUpload";
import { api } from "../../../utils/axios/Config";
import { cn, handleErrorApi } from "../../../utils/utils";
import Loader from "../../shared/Loader";

const FormImageUploader = ({ src, width, height, className }) => {
  const queryClient = useQueryClient();
  const [fileUrl, setFileUrl] = useState("");
  const [file, setFile] = useState([]);
  const [fileIsUploading, setFileIsUploading] = useState(false);

  const { data: user } = useGetUserInformation();
  const userId = user?.id;

  const { progress, uploading, error, uploadFile } = useFileUpload();

  const handleUpload = async ({ file, pic_type }) => {
    setFileIsUploading(true);

    try {
      const session = await uploadFile({ file, pic_type });

      if (session.status === 200) {
        const { url } = session.data;

        try {
          const res = api.patch(`users/update/profile/picture/${userId}/`, {
            profile_pic_url: url,
          });

          res.then((res) => {
            if (res.status === 200) {
              queryClient.invalidateQueries({
                queryKey: usersKeys.me(),
              });
              toast.success("آواتار کاربر ویرایش گردید");
            }
          });
        } catch (error) {
          handleErrorApi(error);
        }

        //console.log(url);
        // fieldChange(url);
      } else {
        //fieldChange("");
      }

      return session;
    } catch (err) {
      //fieldChange("");
      console.error("Error uploading file:", err);
      throw err; // Re-throw to handle errors elsewhere if needed
    } finally {
      setFileIsUploading(false);
    }
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      setFile(acceptedFiles[0]);
      // fieldChange(URL.createObjectURL(acceptedFiles[0]))
      setFileUrl(URL.createObjectURL(acceptedFiles[0]));
      handleUpload({ file: acceptedFiles[0], pic_type: "USER_PROFILE" });
    },
    [file],
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  return (
    <div className="b">
      <>
        <Popup
          trigger={
            <img
              src={src ? src : emptyImage}
              alt="sd"
              className={cn("max-w-[200px] max-h-[150px]", className)}
              width={width}
              height={height}
            />
          }
          modal
        >
          {(close) => (
            <div className="bg-white rounded-xl ">
              {src ? (
                <div className=" flex-between  gap-4 w-full p-2  rounded-xl ">
                  {uploading ? (
                    <div className="w-full">
                      <ProgressBar
                        completed={progress}
                        maxCompleted={100}
                        className="w-full"
                        bgColor="#39A78E"
                      />
                    </div>
                  ) : (
                    <>
                      <img src={src} alt="sd" className="max-w-[60vw] max-h-[60vh] min-w-[40vw]  " />
                    </>
                  )}
                </div>
              ) : (
                <div className="bg-neutral-30 flex-between  gap-4 w-full p-2  rounded-xl">
                  <img
                    src={emptyImage}
                    alt="emptyAvatar"
                    className="size-1 h-[150px] rounded-lg min-w-[150px] min-h-[150px]"
                  />
                </div>
              )}

              <div className="flex justify-center gap-2 p-2">
                <div
                  {...getRootProps()}
                  className="flex flex-col flex-center   bg-dark-3 rounded-xl cursor pointer gap-2 "
                >
                  <input {...getInputProps()} className="cursor-pointer" />
                  <button className="btn-container">
                    {fileIsUploading ? (
                      <>
                        <div className="w-4 h-4">
                          <Loader />
                        </div>
                        <p> در حال ذخیره سازی ...</p>
                      </>
                    ) : (
                      "ویرایش"
                    )}
                  </button>

                  {error && <div style={{ color: "red" }}>خطا:{error.message} </div>}
                </div>
                <button onClick={() => close()} className="btn-cancel">
                  انصراف
                </button>
              </div>
            </div>
          )}
        </Popup>
      </>
    </div>
  );
};

export default FormImageUploader;
